import { z } from "zod";

export const BlueberrySchema = z.object({
  price: z.number().positive(),
});

export const BlueberrySeasonStateSchema = z.enum([
  "open",
  "before_start",
  "after_end",
]);

export const BlueberryResponseSchema = BlueberrySchema.extend({
  season_opening_date: z.string(),
  season_closing_date: z.string(),
  season_message_transition_date: z.string(),
  season_state: BlueberrySeasonStateSchema,
  ordering_available: z.boolean(),
  same_day_order_cutoff_time: z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/),
  blocked_delivery_dates: z
    .array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)),
}).transform((data) => ({
  ...data,
  price: data.price / 100,
}));

export type BlueberryResponse = z.infer<typeof BlueberryResponseSchema>;
export type BlueberrySeasonState = z.infer<typeof BlueberrySeasonStateSchema>;
export type BlueberryUpdatePayload = Partial<
  Pick<
    BlueberryResponse,
    | "price"
    | "season_opening_date"
    | "season_closing_date"
    | "season_message_transition_date"
    | "same_day_order_cutoff_time"
    | "blocked_delivery_dates"
  >
>;
